<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!-- 기타 관계법령에 따른 안전점검 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="기타 관계법령에 따른 안전점검"
      :tableData="[
        { id: 'input1', title: '연번', type: 'no', width: '80px'},
        { id: 'input2', title: '사업명', type: 'text', placeholder: '내용' },
        { id: 'input3', title: '시설명', type: 'text', placeholder: '내용' },
        { id: 'input4', title: '공사개요', type: 'textarea', rows: 3, placeholder: '내용' },
        { id: 'input5', title: '공사시기', type: 'text', placeholder: '내용' },
        { id: 'input6', title: '비고', type: 'text', placeholder: '내용' },
      ]"
      v-model="form.worker"
      :mobile="['input2', 'input3']"
    />

    <!--    사진대지-->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-check-mode="false"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검" />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>

  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import TableCustom from "@/components/TableCustom.vue";

export default {
  components: {
    TableCustom,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      showPopup: false,
      form: {
        stdInfo: {},
        fileList: [],
        photoList: [],
        worker: [{}],
      },
    };
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">

</style>
